import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { submitInquiry } from "../../store/slices/inquiriesSlice";
import { Container } from "../ui/Section";
import { MotionItem, fadeUp, fadeUpSmall } from "../ui/Motion";
import {
  Wrapper,
  Content,
  Eyebrow,
  Title,
  Description,
  Form,
  Input,
  SubmitBtn,
  Note,
  SuccessMsg,
} from "./styles/Newsletter.styles";

function Newsletter() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await dispatch(
        submitInquiry({
          fullName: "Newsletter Subscriber",
          email: email.trim(),
          message: "Newsletter subscription",
          source: "newsletter",
        }),
      ).unwrap();
      setSuccess(true);
      toast.success("Thank you for subscribing!");
    } catch (err) {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Wrapper>
      <Container>
        <Content slow>
          {success ? (
            <SuccessMsg>
              <h3>You're In</h3>
              <p>
                Thank you for subscribing. Watch your inbox for new arrivals
                and market insights.
              </p>
            </SuccessMsg>
          ) : (
            <>
              <MotionItem $variants={fadeUpSmall}>
                <Eyebrow>Stay Informed</Eyebrow>
              </MotionItem>
              <MotionItem $variants={fadeUp}>
                <Title>
                  Be the First to <em>Know</em>
                </Title>
              </MotionItem>
              <MotionItem $variants={fadeUpSmall}>
                <Description>
                  Receive new arrivals, exclusive listings, and market insights
                  from our team, straight to your inbox.
                </Description>
              </MotionItem>
              <MotionItem $variants={fadeUpSmall}>
                <Form onSubmit={handleSubmit}>
                  <Input
                    type="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    aria-label="Email address"
                  />
                  <SubmitBtn type="submit" disabled={submitting}>
                    {submitting ? "Subscribing..." : "Subscribe"}
                  </SubmitBtn>
                </Form>
              </MotionItem>
              <MotionItem $variants={fadeUpSmall}>
                <Note>No spam. Unsubscribe at any time.</Note>
              </MotionItem>
            </>
          )}
        </Content>
      </Container>
    </Wrapper>
  );
}

export default Newsletter;
